import React, { Suspense, FC } from 'react'
import useSWR, { mutate } from 'swr'
import { Typography } from '@creditas/typography'
import { useTranslation } from 'react-i18next'

import {
  fetchData,
  CounterResponse,
} from 'services/api/core/assignments/counter'

import { Card } from './Card'
import { LoadingSpinner } from './LoadingSpinner'
import { LoadingSkeleton } from './LoadingSkeleton'
import { ErrorBoundary } from './ErrorBoundary'

const Counter = () => {
  const { t } = useTranslation(['surprise'])
  const { data, isValidating } = useSWR<CounterResponse>(
    'assignments::counter',
    () => fetchData(),
  )

  const handleClick = (): void => {
    if (isValidating) {
      return
    }

    mutate('assignments::counter')
  }
  return (
    <Card onClick={handleClick}>
      <Typography variant="support">{t('heading.assignmentsCard')}</Typography>
      <Typography variant="support" weight="900">
        {data?.assignments} / {data?.assignmentsAndUnassignments}
        {isValidating && <LoadingSpinner />}
      </Typography>
    </Card>
  )
}

const AssignmentsCounter: FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSkeleton />}>
        <Counter />
      </Suspense>
    </ErrorBoundary>
  )
}

export { AssignmentsCounter }
